"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const graphql_tag_1 = tslib_1.__importDefault(require("graphql-tag"));
const DataProvider_1 = tslib_1.__importDefault(require("../DataProvider"));
const ApiClient_1 = require("../lib/ApiClient");
exports.isLikeNotificationDetails = (details) => {
    var _a;
    return ((_a = details) === null || _a === void 0 ? void 0 : _a[ApiClient_1.typenameSymbol]) === "LikeNotificationDetails";
};
class LikeProvider extends DataProvider_1.default {
    get fragments() {
        return {
            LikesStatistic: () => `
        ... on LikesStatistic {
          subject {
            subjectId
            subjectType
          }
          count
          liked
        }
      `,
            NotificationDetails: () => `
        ... on LikeNotificationDetails {
          contentType
          content {
            __typename
            ${this.getFragment("SubjectDetails")}
          }
        }
      `,
        };
    }
    getStats({ subjects }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.query({
                query: graphql_tag_1.default `
        query LikesGetStats($subjects: [InputLikeSubject]!) {
          likesGetStats(subjects: $subjects) {
            ${this.getFragment("LikesStatistic")}
          }
        }
      `,
                variables: { subjects },
            });
            return response.data.likesGetStats;
        });
    }
    toggle({ subject }) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const response = yield this.api.mutate({
                mutation: graphql_tag_1.default `
        mutation LikesToggle($subject: InputLikeSubject!) {
          likesToggle(data: $subject)
        }
      `,
                variables: { subject },
            });
            return response.data.likesToggle;
        });
    }
}
exports.LikeProvider = LikeProvider;
//# sourceMappingURL=LikeProvider.js.map